import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ICompanyLastSelectedState } from '~/types/company/models'

const apiEntityPath = '/api/companylastselectedstates'

export async function createCompanyLastSelectedState(
  entity: ICompanyLastSelectedState
) {
  const callingMn = createCompanyLastSelectedState.name
  const apiPath = apiEntityPath
  return httpPost<ICompanyLastSelectedState>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateCompanyLastSelectedState(
  entityData: Partial<ICompanyLastSelectedState>,
  id: TEntityId
) {
  const callingMn = updateCompanyLastSelectedState.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialCompanyLastSelectedState = Partial<ICompanyLastSelectedState>
  return httpPatchMerge<TPartialCompanyLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCompanyLastSelectedState(
  entityData: ICompanyLastSelectedState
) {
  const callingMn = deleteCompanyLastSelectedState.name
  const apiPath = apiEntityPath
  return httpDelete<ICompanyLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}
